// EarlyAccessBanner — retired per Zero Friction product directive.
// Returning null keeps every existing import working without touching individual tool files.
export function EarlyAccessBanner() {
  return null;
}
